/*
 * <countdown-timer data-end="2026-10-10T23:59:00+08:00">
 *   children: [data-countdown-part="days|hours|minutes|seconds"] receive zero-padded numbers.
 * Dispatches `countdown:expired` (bubbles) once when the deadline passes and sets the `expired` attribute.
 * If the scope has [data-hide-expired] the whole scope is hidden on expiry.
 * Optional: [data-countdown-expired] elements are un-hidden on expiry, [data-countdown-live] elements are hidden.
 */
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end || '');
      if (Number.isNaN(this.end)) return;
      this.parts = {};
      for (const el of this.querySelectorAll('[data-countdown-part]')) this.parts[el.dataset.countdownPart] = el;
      this.tick();
      if (!this.hasAttribute('expired')) this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const diff = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      const pad = (n) => String(n).padStart(2, '0');
      const values = {
        days: pad(Math.floor(diff / 86400)),
        hours: pad(Math.floor((diff % 86400) / 3600)),
        minutes: pad(Math.floor((diff % 3600) / 60)),
        seconds: pad(diff % 60),
      };
      for (const [key, el] of Object.entries(this.parts)) {
        if (el.textContent !== values[key]) el.textContent = values[key];
      }
      if (diff === 0) this.expire();
    }

    expire() {
      clearInterval(this.timer);
      if (this.hasAttribute('expired')) return;
      this.setAttribute('expired', '');
      const scope = this.closest('[data-countdown-scope]') || this;
      for (const el of scope.querySelectorAll('[data-countdown-expired]')) el.hidden = false;
      for (const el of scope.querySelectorAll('[data-countdown-live]')) el.hidden = true;
      if (scope.hasAttribute('data-hide-expired')) scope.hidden = true;
      this.dispatchEvent(new CustomEvent('countdown:expired', { bubbles: true }));
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
}
